import React, { useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Renderhamburgermenu } from "../../Components/hamburger/hamburger-menu";
import Dashboardcardlayout from "../Layout/Layout";
import Received from "./Received/Received";
import ResponsiveReceivedTab from "./Responsive/Received-Tab";
import Sent from "./Sent/Sent";
import ResponsiveSentTab from "./Responsive/Sent-Tab";
import MyInvitationsIcon from "../../../images/new-images/MyinvitationsImg.png";
import "./invitations.css";
import Sentrespondantsfiltered from "./Sent/SentRespondentFiltered";
import ResponsiveSentRespondantsFiltered from "./Responsive/SentRespondantsFiltered";
import ResponsiveDashboardcardlayout from "../Layout/ResponsiveLayout";

const invitationTabs = (props) => {


  const calcWidth = window.innerWidth;


  useEffect(() => {
    // Check if loading is complete, we're in Sentrespondantsfiltered tab, and there are zero sent invitations
    if (!props.isLoading &&
      props.sentRespondantsId &&
      props.sentRespondantsId === props.sentRespondantsFilteredId &&
      props.filteredSentRespondants &&
      props.filteredSentRespondants.respondents &&
      props.filteredSentRespondants.respondents.length === 0) {
      // Show the invite respondents modal
      props.handleInvitationsModal();
    }
  }, [props.isLoading, props.sentRespondantsId, props.sentRespondantsFilteredId, props.filteredSentRespondants]);

  // Loading spinner component
  const LoadingSpinner = () => (
    <div className="loading-spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );







  const ReceivedTab = ({ children }) => (
    <Tab>
      <div
        className={props.receivedTab ? "activeTab" : ""}
        onClick={props.handleReceivedTab}
      >
        {children}
      </div>
    </Tab>
  );
  ReceivedTab.tabsRole = "Tab";

  const SentTab = ({ children }) => (
    <Tab>
      <div
        className={props.sentTab ? "activeTab" : ""}
        onClick={props.handleSentTab}
      >
        {children}
      </div>
    </Tab>
  );
  SentTab.tabsRole = "Tab";


  // Show loading spinner if data is being fetched
  if (props.isLoading) {
    return (
      <div>
        {calcWidth > 768 ? (
          <Dashboardcardlayout headerIcon={MyInvitationsIcon} headerText="My Invitations">
            <LoadingSpinner />
          </Dashboardcardlayout>
        ) : (
          <ResponsiveDashboardcardlayout headerIcon={MyInvitationsIcon} headerText="My Invitations" marginStyle="dashboard-summary">
            <LoadingSpinner />
          </ResponsiveDashboardcardlayout>
        )}
      </div>
    );
  }






  return (
    <div>
      {calcWidth > 768 ? <Dashboardcardlayout
        headerIcon={MyInvitationsIcon}
        headerText="My Invitations"
      >
        <Renderhamburgermenu
          link1="/new/app/dashBoard"
          link2="/new/app/Invitations"
          text1="Dashboard"
          text2="Invitations"
          reviewMode={props.reviewMode}
        />
        {props.sentRespondantsId &&
          props.sentRespondantsId == props.sentRespondantsFilteredId &&
          props.sentRespondantsFilteredId ? (
          calcWidth <= 767 ? (
            <ResponsiveSentRespondantsFiltered
              filteredSentRespondants={props.filteredSentRespondants}
              editModal={props.editModal}
              deleteModal={props.deleteModal}
              handleEditModalSubmit={props.handleEditModalSubmit}
              handleEditModal={props.handleEditModal}
              handleDeleteModal={props.handleDeleteModal}
              respondentEmail={props.respondentEmail}
              respondentRelationship={props.respondentRelationship}
              respondentInvitationsModal={props.respondentInvitationsModal}
              inputFields={props.inputFields}
              handleInputFields={props.handleInputFields}
              dropDownOptions={props.dropDownOptions}
              handleInvitationsEmail={props.handleInvitationsEmail}
              isChecked={props.isChecked}
              isDisabled={props.isDisabled}
              handleModalFormSubmit={props.handleModalFormSubmit}
              handleInvitationsModal={props.handleInvitationsModal}
              respondantStatus={props.respondantStatus}
              receivedInvitations={props.receivedInvitations}
              minRespondants={props.minRespondants}
              getRespondantStatus={props.getRespondantStatus}
              getUrlString={props.getUrlString}
              batchMinRespondants={props.batchMinRespondants}
              handleReminder={props.handleReminder}
              respondantUserAssessmentId={props.respondantUserAssessmentId}
              respondantIndividualId={props.respondantIndividualId}
              handleDeleteRequest={props.handleDeleteRequest}
              sentRespondants={props.sentRespondants}
              sentRespondantsId={props.sentRespondantsId}
              sentRespondantsFilteredId={props.sentRespondantsFilteredId}
              handleModalClose={props.handleModalClose}
              assessmentUserId={props.assessmentUserId}
              accessorGroupId={props.accessorGroupId}
              relationShipId={props.relationShipId}
              handleDropdownOptions={props.handleDropdownOptions}
              handleRelationDropdown={props.handleRelationDropdown}
              handleModalSubmit={props.handleModalSubmit}
              respondantConfirmModal={props.respondantConfirmModal}
              invitationsSuccessMessage={props.invitationsSuccessMessage}
              collapseID={props.collapseID}
              toggleCollapse={props.toggleCollapse}
              idOfParticipant={props.idOfParticipant}
              isMultiRater={props.isMultiRater}
            />
          ) : (
            <Sentrespondantsfiltered
              filteredSentRespondants={props.filteredSentRespondants}
              editModal={props.editModal}
              deleteModal={props.deleteModal}
              handleEditModalSubmit={props.handleEditModalSubmit}
              handleEditModal={props.handleEditModal}
              handleDeleteModal={props.handleDeleteModal}
              respondentEmail={props.respondentEmail}
              respondentRelationship={props.respondentRelationship}
              respondentInvitationsModal={props.respondentInvitationsModal}
              inputFields={props.inputFields}
              handleInputFields={props.handleInputFields}
              dropDownOptions={props.dropDownOptions}
              handleInvitationsEmail={props.handleInvitationsEmail}
              isChecked={props.isChecked}
              isDisabled={props.isDisabled}
              handleModalFormSubmit={props.handleModalFormSubmit}
              handleInvitationsModal={props.handleInvitationsModal}
              respondantStatus={props.respondantStatus}
              receivedInvitations={props.receivedInvitations}
              minRespondants={props.minRespondants}
              getRespondantStatus={props.getRespondantStatus}
              getUrlString={props.getUrlString}
              batchMinRespondants={props.batchMinRespondants}
              handleReminder={props.handleReminder}
              respondantUserAssessmentId={props.respondantUserAssessmentId}
              respondantIndividualId={props.respondantIndividualId}
              handleDeleteRequest={props.handleDeleteRequest}
              sentRespondants={props.sentRespondants}
              sentRespondantsId={props.sentRespondantsId}
              sentRespondantsFilteredId={props.sentRespondantsFilteredId}
              handleModalClose={props.handleModalClose}
              assessmentUserId={props.assessmentUserId}
              accessorGroupId={props.accessorGroupId}
              relationShipId={props.relationShipId}
              handleDropdownOptions={props.handleDropdownOptions}
              handleRelationDropdown={props.handleRelationDropdown}
              handleModalSubmit={props.handleModalSubmit}
              respondantConfirmModal={props.respondantConfirmModal}
              invitationsSuccessMessage={props.invitationsSuccessMessage}
              idOfParticipant={props.idOfParticipant}
              isMultiRater={props.isMultiRater}
            />
          )
        ) : (
          <Tabs
            selectedIndex={props.tabIndex}
            onSelect={(index) => props.setTabIndex(index)}
          >
            <TabList className="custom-tabs">
              <ReceivedTab>Received</ReceivedTab>
              <div className="Line"></div>
              <SentTab>Sent</SentTab>
            </TabList>
            <TabPanel>
              {calcWidth <= 767 ? (
                <ResponsiveReceivedTab
                  receivedInvitations={props.receivedInvitations}
                  numberCount={props.numberCount}
                  completedCount={props.completedCount}
                  collapseID={props.collapseID}
                  toggleCollapse={props.toggleCollapse}
                  getRespondantStatus={props.getRespondantStatus}
                  sentRespondants={props.sentRespondants}
                />
              ) : (
                <Received
                  receivedInvitations={props.receivedInvitations}
                  numberCount={props.numberCount}
                  completedCount={props.completedCount}
                  getRespondantStatus={props.getRespondantStatus}
                  sentRespondants={props.sentRespondants}
                />
              )}
            </TabPanel>
            <TabPanel>
              {calcWidth <= 767 ? (
                <ResponsiveSentTab
                  editModal={props.editModal}
                  deleteModal={props.deleteModal}
                  handleModalClose={props.handleModalClose}
                  handleEditModal={props.handleEditModal}
                  handleDeleteModal={props.handleDeleteModal}
                  respondentEmail={props.respondentEmail}
                  respondentRelationship={props.respondentRelationship}
                  respondentInvitationsModal={props.respondentInvitationsModal}
                  inputFields={props.inputFields}
                  handleInputFields={props.handleInputFields}
                  dropDownOptions={props.dropDownOptions}
                  handleModalFormSubmit={props.handleModalFormSubmit}
                  handleInvitationsModal={props.handleInvitationsModal}
                  respondantStatus={props.respondantStatus}
                  receivedInvitations={props.receivedInvitations}
                  sentRespondants={props.sentRespondants}
                  minRespondants={props.minRespondants}
                  getRespondantStatus={props.getRespondantStatus}
                  batchMinRespondants={props.batchMinRespondants}
                  handleReminder={props.handleReminder}
                  respondantUserAssessmentId={props.respondantUserAssessmentId}
                  respondantIndividualId={props.respondantIndividualId}
                  handleDeleteRequest={props.handleDeleteRequest}
                  collapseID={props.collapseID}
                  toggleCollapse={props.toggleCollapse}
                  handleEditModalSubmit={props.handleEditModalSubmit}
                />
              ) : (
                <Sent
                  editModal={props.editModal}
                  deleteModal={props.deleteModal}
                  handleModalClose={props.handleModalClose}
                  handleEditModal={props.handleEditModal}
                  handleDeleteModal={props.handleDeleteModal}
                  respondentEmail={props.respondentEmail}
                  respondentRelationship={props.respondentRelationship}
                  respondentInvitationsModal={props.respondentInvitationsModal}
                  inputFields={props.inputFields}
                  handleInputFields={props.handleInputFields}
                  dropDownOptions={props.dropDownOptions}
                  handleModalFormSubmit={props.handleModalFormSubmit}
                  handleInvitationsModal={props.handleInvitationsModal}
                  respondantStatus={props.respondantStatus}
                  receivedInvitations={props.receivedInvitations}
                  sentRespondants={props.sentRespondants}
                  minRespondants={props.minRespondants}
                  getRespondantStatus={props.getRespondantStatus}
                  batchMinRespondants={props.batchMinRespondants}
                  handleReminder={props.handleReminder}
                  respondantUserAssessmentId={props.respondantUserAssessmentId}
                  respondantIndividualId={props.respondantIndividualId}
                  handleDeleteRequest={props.handleDeleteRequest}
                  handleEditModalSubmit={props.handleEditModalSubmit}
                />
              )}
            </TabPanel>
          </Tabs>
        )}
      </Dashboardcardlayout>
        :
        <ResponsiveDashboardcardlayout
          headerIcon={MyInvitationsIcon}
          headerText="My Invitations"
          marginStyle='dashboard-summary'
        >
          <Renderhamburgermenu
            link1="/new/app/dashBoard"
            link2="/new/app/Invitations"
            text1="Dashboard"
            text2="Invitations"
            reviewMode={props.reviewMode}
          />
          {props.sentRespondantsId &&
            props.sentRespondantsId == props.sentRespondantsFilteredId &&
            props.sentRespondantsFilteredId ? (
            calcWidth <= 767 ? (
              <ResponsiveSentRespondantsFiltered
                filteredSentRespondants={props.filteredSentRespondants}
                editModal={props.editModal}
                deleteModal={props.deleteModal}
                handleEditModalSubmit={props.handleEditModalSubmit}
                handleEditModal={props.handleEditModal}
                handleDeleteModal={props.handleDeleteModal}
                respondentEmail={props.respondentEmail}
                respondentRelationship={props.respondentRelationship}
                respondentInvitationsModal={props.respondentInvitationsModal}
                inputFields={props.inputFields}
                handleInputFields={props.handleInputFields}
                dropDownOptions={props.dropDownOptions}
                handleInvitationsEmail={props.handleInvitationsEmail}
                isChecked={props.isChecked}
                isDisabled={props.isDisabled}
                handleModalFormSubmit={props.handleModalFormSubmit}
                handleInvitationsModal={props.handleInvitationsModal}
                respondantStatus={props.respondantStatus}
                receivedInvitations={props.receivedInvitations}
                minRespondants={props.minRespondants}
                getRespondantStatus={props.getRespondantStatus}
                getUrlString={props.getUrlString}
                batchMinRespondants={props.batchMinRespondants}
                handleReminder={props.handleReminder}
                respondantUserAssessmentId={props.respondantUserAssessmentId}
                respondantIndividualId={props.respondantIndividualId}
                handleDeleteRequest={props.handleDeleteRequest}
                sentRespondants={props.sentRespondants}
                sentRespondantsId={props.sentRespondantsId}
                sentRespondantsFilteredId={props.sentRespondantsFilteredId}
                handleModalClose={props.handleModalClose}
                assessmentUserId={props.assessmentUserId}
                accessorGroupId={props.accessorGroupId}
                relationShipId={props.relationShipId}
                handleDropdownOptions={props.handleDropdownOptions}
                handleRelationDropdown={props.handleRelationDropdown}
                handleModalSubmit={props.handleModalSubmit}
                respondantConfirmModal={props.respondantConfirmModal}
                invitationsSuccessMessage={props.invitationsSuccessMessage}
                collapseID={props.collapseID}
                toggleCollapse={props.toggleCollapse}
                idOfParticipant={props.idOfParticipant}
                isMultiRater={props.isMultiRater}
              />
            ) : (
              <Sentrespondantsfiltered
                filteredSentRespondants={props.filteredSentRespondants}
                editModal={props.editModal}
                deleteModal={props.deleteModal}
                handleEditModalSubmit={props.handleEditModalSubmit}
                handleEditModal={props.handleEditModal}
                handleDeleteModal={props.handleDeleteModal}
                respondentEmail={props.respondentEmail}
                respondentRelationship={props.respondentRelationship}
                respondentInvitationsModal={props.respondentInvitationsModal}
                inputFields={props.inputFields}
                handleInputFields={props.handleInputFields}
                dropDownOptions={props.dropDownOptions}
                handleInvitationsEmail={props.handleInvitationsEmail}
                isChecked={props.isChecked}
                isDisabled={props.isDisabled}
                handleModalFormSubmit={props.handleModalFormSubmit}
                handleInvitationsModal={props.handleInvitationsModal}
                respondantStatus={props.respondantStatus}
                receivedInvitations={props.receivedInvitations}
                minRespondants={props.minRespondants}
                getRespondantStatus={props.getRespondantStatus}
                getUrlString={props.getUrlString}
                batchMinRespondants={props.batchMinRespondants}
                handleReminder={props.handleReminder}
                respondantUserAssessmentId={props.respondantUserAssessmentId}
                respondantIndividualId={props.respondantIndividualId}
                handleDeleteRequest={props.handleDeleteRequest}
                sentRespondants={props.sentRespondants}
                sentRespondantsId={props.sentRespondantsId}
                sentRespondantsFilteredId={props.sentRespondantsFilteredId}
                handleModalClose={props.handleModalClose}
                assessmentUserId={props.assessmentUserId}
                accessorGroupId={props.accessorGroupId}
                relationShipId={props.relationShipId}
                handleDropdownOptions={props.handleDropdownOptions}
                handleRelationDropdown={props.handleRelationDropdown}
                handleModalSubmit={props.handleModalSubmit}
                respondantConfirmModal={props.respondantConfirmModal}
                invitationsSuccessMessage={props.invitationsSuccessMessage}
                idOfParticipant={props.idOfParticipant}
                isMultiRater={props.isMultiRater}
              />
            )
          ) : (
            <Tabs
              selectedIndex={props.tabIndex}
              onSelect={(index) => props.setTabIndex(index)}
            >
              <TabList className="custom-tabs">
                <ReceivedTab>Received</ReceivedTab>
                <div className="Line"></div>
                <SentTab>Sent</SentTab>
              </TabList>
              <TabPanel>
                {calcWidth <= 767 ? (
                  <ResponsiveReceivedTab
                    receivedInvitations={props.receivedInvitations}
                    numberCount={props.numberCount}
                    completedCount={props.completedCount}
                    collapseID={props.collapseID}
                    toggleCollapse={props.toggleCollapse}
                    getRespondantStatus={props.getRespondantStatus}
                    sentRespondants={props.sentRespondants}
                  />
                ) : (
                  <Received
                    receivedInvitations={props.receivedInvitations}
                    numberCount={props.numberCount}
                    completedCount={props.completedCount}
                    getRespondantStatus={props.getRespondantStatus}
                    sentRespondants={props.sentRespondants}
                  />
                )}
              </TabPanel>
              <TabPanel>
                {calcWidth <= 767 ? (
                  <ResponsiveSentTab
                    editModal={props.editModal}
                    deleteModal={props.deleteModal}
                    handleModalClose={props.handleModalClose}
                    handleEditModal={props.handleEditModal}
                    handleDeleteModal={props.handleDeleteModal}
                    respondentEmail={props.respondentEmail}
                    respondentRelationship={props.respondentRelationship}
                    respondentInvitationsModal={props.respondentInvitationsModal}
                    inputFields={props.inputFields}
                    handleInputFields={props.handleInputFields}
                    dropDownOptions={props.dropDownOptions}
                    handleModalFormSubmit={props.handleModalFormSubmit}
                    handleInvitationsModal={props.handleInvitationsModal}
                    respondantStatus={props.respondantStatus}
                    receivedInvitations={props.receivedInvitations}
                    sentRespondants={props.sentRespondants}
                    minRespondants={props.minRespondants}
                    getRespondantStatus={props.getRespondantStatus}
                    batchMinRespondants={props.batchMinRespondants}
                    handleReminder={props.handleReminder}
                    respondantUserAssessmentId={props.respondantUserAssessmentId}
                    respondantIndividualId={props.respondantIndividualId}
                    handleDeleteRequest={props.handleDeleteRequest}
                    collapseID={props.collapseID}
                    toggleCollapse={props.toggleCollapse}
                    handleEditModalSubmit={props.handleEditModalSubmit}
                  />
                ) : (
                  <Sent
                    editModal={props.editModal}
                    deleteModal={props.deleteModal}
                    handleModalClose={props.handleModalClose}
                    handleEditModal={props.handleEditModal}
                    handleDeleteModal={props.handleDeleteModal}
                    respondentEmail={props.respondentEmail}
                    respondentRelationship={props.respondentRelationship}
                    respondentInvitationsModal={props.respondentInvitationsModal}
                    inputFields={props.inputFields}
                    handleInputFields={props.handleInputFields}
                    dropDownOptions={props.dropDownOptions}
                    handleModalFormSubmit={props.handleModalFormSubmit}
                    handleInvitationsModal={props.handleInvitationsModal}
                    respondantStatus={props.respondantStatus}
                    receivedInvitations={props.receivedInvitations}
                    sentRespondants={props.sentRespondants}
                    minRespondants={props.minRespondants}
                    getRespondantStatus={props.getRespondantStatus}
                    batchMinRespondants={props.batchMinRespondants}
                    handleReminder={props.handleReminder}
                    respondantUserAssessmentId={props.respondantUserAssessmentId}
                    respondantIndividualId={props.respondantIndividualId}
                    handleDeleteRequest={props.handleDeleteRequest}
                    handleEditModalSubmit={props.handleEditModalSubmit}
                  />
                )}
              </TabPanel>
            </Tabs>
          )}
        </ResponsiveDashboardcardlayout>
      }
    </div>
  );
};
export default invitationTabs;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/invitations.jsx